import { DashCard } from "../../../../script/components/dash-board/dash-card/dash-card";
import { ScrollGrid } from "../../../../script/components/data-grid/data-grid-body/grid-bodys";
import { CommCol, DeciCol } from "../../../../script/components/data-grid/data-grid-column/grid-column";
import { Summary } from "devextreme-react/cjs/data-grid";
import { GroupSumItem } from "../../../../script/components/data-grid/data-grid-body/grid-body-item";
import { fwUtil } from "../../../../script/util";

const clieGroupRender = (data) => {

    if (!data && (data && data.length < 1)) {
        return;
    }

    if (!data.summaryItems) {
        return;
    }
    const shipColumn = data.summaryItems[0];
    const kwonColumn = data.summaryItems[1];

    if (!shipColumn || !kwonColumn) {
        return;
    }

    return (
        <div className='fw-summary-group'>
            <div className='fw-group-title'>
                {data.displayValue}
            </div>
            <div className='fw-group-detail'>
                총 {shipColumn.columnCaption} : <b>{shipColumn.value}</b> 
            </div>
            <div className='fw-group-detail'>
                총 {kwonColumn.columnCaption} : <b>{fwUtil.conv.to.krLocales(kwonColumn.value)}</b> 원
            </div>
        </div>
    )
}

export function DashClieGridCard(props) {
    const { loading, data } = props;

    return (
        <DashCard
            title={"업체별 현황"}
            addClass={'clie'}
            loading={loading}
        >
            <ScrollGrid
                gridDataSource={data}
                height={250}
                mainKey={["item_code", "clie_code"]}
                selection={'single'}
                direction={'vertical'}
            >
                {CommCol({ dataField: "clie_name", caption: "업체명", groupIndex: 0, groupRender: clieGroupRender })}
                {CommCol({ dataField: "item_name", caption: "제품명" })}
                {DeciCol({ dataField: "ship_qtys", caption: "납품" })}
                {DeciCol({ dataField: "ship_kwon", caption: "금액", suffix: "원" })}
                <Summary>
                    {GroupSumItem({ dataField: "ship_qtys", suffix: "개" })}
                    {GroupSumItem({ dataField: "ship_kwon", suffix: "원" })}
                </Summary>
            </ScrollGrid>
        </DashCard>
    )
}